import { render } from "./btn.vue?vue&type=template&id=ebcbeaf8&scoped=true"
import script from "./btn.vue?vue&type=script&lang=js"
export * from "./btn.vue?vue&type=script&lang=js"

import "./btn.vue?vue&type=style&index=0&id=ebcbeaf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebcbeaf8"]])

export default __exports__